import { useParams } from "react-router-dom";
import ExcelEditor from "./ExcelEditor";
import { useEffect, useState } from "react";
import { StyledExcel } from "./styles";
import { Empty, Spin } from "antd";
import httpClient from "../../../api/httpClient";
import { useSelector } from "react-redux";
import { selectSelectedTenantId } from "../../../store/user/selectors";

const Excel = () => {
  const [loading, setLoading] = useState(false);
  const [spreadSheetData, setSpreadSheetData] = useState(null);

  const tenant_id = useSelector(selectSelectedTenantId);
  const { workbook_id } = useParams();

  useEffect(() => {
    if (!tenant_id || !workbook_id) return;

    const fetchSpreadsheetData = async () => {
      try {
        setLoading(true);

        const response = await httpClient.get("spreadsheet/file-folder", {
          params: {
            tenant_id,
            workbook_id,
            type: "spreadsheet",
          },
        });

        setSpreadSheetData(response?.data || null);
      } catch (error) {
        console.error("Error fetching spreadsheet data:", error);
        setSpreadSheetData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchSpreadsheetData();
  }, [tenant_id, workbook_id]);

  return (
    <StyledExcel>
      {loading ? (
        <div className="loading flex-center">
          <Spin size="large" />
        </div>
      ) : spreadSheetData ? (
        <ExcelEditor
          spreadSheetData={spreadSheetData}
          setSpreadSheetData={setSpreadSheetData}
        />
      ) : (
        <div className="loading flex-center">
          <Empty description="Spread Sheet Not Found" />
        </div>
      )}
    </StyledExcel>
  );
};

export default Excel;
